<template>
  <div class="select-checkbox-container">
    <div v-for="(option, i) in options" :key="i">
      <div class="single-container">
        <div class="text">
          <div class="name">{{ option.name }}</div>
          <small>{{ option.description }}</small>
        </div>
        <div class="mdc-touch-target-wrapper">
          <div class="mdc-checkbox mdc-checkbox--touch">
            <input
              type="checkbox"
              class="mdc-checkbox__native-control"
              id="checkbox"
              :checked="option.value"
              @change="handleSelect(i)"
            />
            <div class="mdc-checkbox__background">
              <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                <path
                  class="mdc-checkbox__checkmark-path"
                  fill="none"
                  d="M1.73,12.91 8.1,19.28 22.79,4.59"
                />
              </svg>
              <div class="mdc-checkbox__mixedmark"></div>
            </div>
            <div class="mdc-checkbox__ripple"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    onChange: Function,
  },

  methods: {
    handleSelect(index) {
      this.options.forEach((option, i) => {
        option.value = i === index;
      });
      this.onChange(this.options[index]);
    },
  },

  mounted() {
    const checkbox = new MDCCheckbox(document.querySelector('checkbox-0'));
    checkbox.listen('');
  },
};
</script>

<style lang="scss">
@import '../../assets/scss/variables';

.select-checkbox-container {
  .single-container {
    display: flex;
    justify-content: space-between;

    .text {
      align-self: center;
      font-family: Roboto;
      font-size: 11px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.45;
      letter-spacing: normal;
      color: #757575;
      position: relative;
      top: -8px;

      .name {
        color: rgba(0, 0, 0, 0.87);
      }
    }
    .mdc-checkbox {
      margin: 0;
      position: relative;
      left: 0.5rem;

      .mdc-checkbox__background {
        border-color: #bdbdbd !important;
        border-radius: 50px;
        width: 2rem;
        height: 2rem;
      }
      .mdc-checkbox__native-control:enabled:checked
        ~ .mdc-checkbox__background {
        background-color: $blue !important;
        border-color: $blue !important;
      }
    }
  }
}
</style>
